import React from 'react';
import styles from './ModuleLibrary.module.css';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setSelectedModule } from '../../redux/actions/operationalActions';

export default function ModuleDetails({ module }) {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();

  const specificCategories = [
    { name: 'Serial number', key: 'serialNumber' },
    { name: 'Module ID', key: 'id' },
    { name: 'Mileage', key: 'mileage' },
    { name: 'Charging cycles', key: 'chargingCycles' },
    { name: 'Prod. year', key: 'productionYear' }
  ];

  const templateCategories = [
    { name: 'Car model', key: 'carModel' },
    { name: 'Module type', key: 'moduleType' },
    { name: 'Chemistry', key: 'chemistryType' },
    { name: 'Cell type', key: 'cellType' },
    { name: 'OEM', key: 'batteryCellManufacturer' }
  ];

  const handleEditClicked = () => {
    dispatch(setSelectedModule(module));
    history.push(`/editmodule`);
  };

  return module ? (
    <div className={styles.moduleDetails}>
      <div className={styles.moduleDetailsHeader}>
        <h2>{t('moduleInfo')}</h2>
        <IconButton onClick={handleEditClicked}>
          <EditIcon />
        </IconButton>
      </div>
      <DetailsRows
        header={'Specific'}
        displayedCategories={specificCategories}
        details={module}
      />
      <DetailsRows
        header={'General'}
        displayedCategories={templateCategories}
        details={module.template}
      />
    </div>
  ) : null;
}

function DetailsRows({ header, displayedCategories, details }) {
  return (
    <div>
      <h3 className={styles.detailRowsHeader}>{header}</h3>
      {displayedCategories.map((data) => (
        <div key={data.name} className={styles.moduleDetail}>
          <p className={styles.moduleDetailKey}>{data.name}</p>
          <p className={styles.moduleDetailValue}>{details[data.key]}</p>
        </div>
      ))}
    </div>
  );
}
